import { render, staticRenderFns } from "./BatchSchedule.vue?vue&type=template&id=45550f10&"
import script from "./BatchSchedule.vue?vue&type=script&lang=js&"
export * from "./BatchSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports